export enum TagPanelEvents {
  Close = 'tagPanelEventClose',
  MaybeClose = 'tagPanelEventMaybeClose',
}

export class OnTagPanelClose extends CustomEvent<{}> {
  constructor() {
    super(TagPanelEvents.Close, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnTagPanelMaybeClose extends CustomEvent<{}> {
  constructor() {
    super(TagPanelEvents.MaybeClose, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}
